module.exports = __webpack_public_path__ + "img/ax.95769b47.svg";